import { motion } from "framer-motion";
import type { ReactNode } from "react";

export function AnimatedText({
  children,
  className = "",
  delay = 0,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-20px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function AnimatedTitle({
  title,
  className = "",
}: {
  title: string;
  className?: string;
}) {
  return (
    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-20px" }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className={`font-bold tracking-wide ${className}`}
    >
      {title}
    </motion.h2>
  );
}
